<!-- display addToCart Icon/animated Icon or link-->
@if (visible$ | async) {
<button
  type="button"
  name="addProduct"
  class="btn rounded-circle"
  [ngClass]="cssClass"
  [title]="displayType === 'icon' ? ('product.add_to_wishlist.link' | translate) : ''"
  [tabindex]="ariaHidden ? -1 : 0"
  [attr.aria-hidden]="ariaHidden"
  (click)="openModal(modal)"
  data-testing-id="addToWishlistButton"
>
  @switch (displayType) { @case ('animated') {
  <!-- <fa-icon [icon]="['fas', 'heart']" [title]="'product.add_to_wishlist.link' | translate"></fa-icon> -->
  <i class="icon-heart"></i>
  <span class="share-label">{{ 'product.add_to_wishlist.link' | translate }}</span>
  } @case ('icon') {
  <i class="icon-heart" title="{{ 'product.add_to_wishlist.link' | translate }}"></i>
  } @default {
  <i class="icon-heart"></i>
  <span class="share-label">{{ 'product.add_to_wishlist.link' | translate }}</span>
  } }
</button>
}

<ish-select-wishlist-modal #modal (submitEmitter)="addProductToWishlist($event)" />
